import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppLayout } from 'components/AppLayout'
import { useOrganizationScopeOrNull } from 'components/OrganizationScope/context'
import { Button } from 'components/Button'
import { pageCardClasses } from 'components/AppLayout/styles'
import { commonStrings } from 'constants/strings'

type ManagementFormLayoutProps = {
  kicker: string
  title: string
  description: string
  backTo: string
  children: ReactNode
  maxWidthClassName?: string
}

export function ManagementFormLayout({
  kicker,
  title,
  description,
  backTo,
  children,
  maxWidthClassName = 'max-w-[920px]',
}: ManagementFormLayoutProps) {
  const navigate = useNavigate()
  // OrganizationScope 内（組織スコープ画面）では AppLayout が既に外側にあるため
  // ラップしない。ADMIN グローバル画面では従来どおり AppLayout でラップする。
  const organizationScope = useOrganizationScopeOrNull()

  const content = (
    <section
        className={`mx-auto w-full ${maxWidthClassName} ${pageCardClasses.large}`}
      >
        <header className="flex flex-wrap items-start justify-between gap-4">
          <div className="grid gap-2">
            <span className="text-[0.65rem] font-semibold uppercase tracking-[0.2em] text-muted">
              {kicker}
            </span>
            <h1 className="text-2xl font-display text-ink">{title}</h1>
            <p className="text-sm text-muted">{description}</p>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Button
              type="button"
              size="sm"
              variant="outline"
              onClick={() => navigate(backTo)}
            >
              {commonStrings.actions.backToList}
            </Button>
          </div>
        </header>

        <div className="mt-6 grid gap-4">{children}</div>
    </section>
  )

  return organizationScope ? content : <AppLayout>{content}</AppLayout>
}
